import React from 'react';
import TopPanel from "./toppanel.js";
import CheckListView from "./checklists/checklistview.js";

module.exports = React.createClass({
    successRequest: function(reply) {
        if (this.state.needGoBack)
            this.goBack();
        this.state.commandCounter--;
        if (this.state.commandCounter == 0) { // don't update model is there're other commands in queue
            if (this.state.selectFirst)
                this.state.selectedId = null;
            HC_SetDataAndSelectedItem(this, reply.data, {needGoBack: false, afterFailState: false});
        }
    },

    successPasswordRequest: function(reply) {
        this.successRequest(reply);
        HC_ShowMessage(HC_LANG.ADM_PASS_CHANGED);
    },

    errorCreateRequest: function (code, errorString) {
        this.state.commandCounter--;
        if (code == 409 && errorString.indexOf("DUPLICATED_EMAIL") >= 0) {
            this.state.existingUsers[errorString.slice(errorString.indexOf("DUPLICATED_EMAIL") + 17).toLowerCase()] = true;
            HC_Validate();
        }
        else
            HC_SetError(code, errorString);
    },

    loadFromServer: function() {
        this.state.commandCounter++;
        HC_SendRequest("users", null, this.successRequest, null);
    },

    getInitialState: function() {
        return {
            data: [],
            selectedId: null,
            needGoBack: false,
            commandCounter: 0,
            newUser: {},
            noData: true,
            existingUsers:{},
            afterFailState: false,
            selectFirst: false,
            password : '',
            confirmPassword: ''
        };
    },
    componentWillMount: function() {
        HC_CheckLoginAndAcc(this, HC_AccAdmin);
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-administrate");
        this.loadFromServer();
        HC_SubscribeHammerEvent(this.refs.hc_user_content, "swiperight", this.goBack);
    },
    componentWillUnmount: function() {
        HC_UnsubscribeHammerEvent(this.refs.hc_user_content, "swiperight");
    },
    handleOnSelected: function(e, createNew=false) {
        var state = {selectedId: e, password: '', confirmPassword: '', afterFailState: false};
        if (e != this.state.selectedId) {
            state.createMode = false;
            if (this.state.data.length > 0 && this.state.data[0].id == -1)
                this.state.data.shift();  // remove fake New User item
        }
        if (createNew)
            state.createMode = true;
        if (HC_DeviceType() == HC_CONST.SCR_PHONE) {
            this.setState(state);
            HC_SwitchRPanel();
        } else
            this.setState(state);
        HC_Validate(null, true);
    },
    getItemCaption: function(o) {
        return o.name;
    },
    getItemText: function(o) {
        var i = 0;
        var strings = [
            HC_LANG.ADM_EMAIL + ": " + (o.email ? o.email : ''),
            HC_LANG.ADM_LAST_LOGIN + ": " + (o.last_login ? HC_FormatDateFull(o.last_login) : HC_LANG.DUE_NEVER),
            HC_LANG.ADM_NUM_LOGINS + ": " + (o.login_count ? o.login_count : '0'),
        ].map(function(s) {return (<div key={i++}>{s}</div>);});
        return <div>{strings}</div>;
    },
    goBack: function() {
        HC_RestoreRPanel();
        if (this.state.data.length > 0 && this.state.data[0].id == -1) {
            this.state.data.shift();  // remove fake New User item
            this.state.selectedId = this.state.data.length > 0 ? this.state.data[0].id : null;
        }
        this.setState({createMode: false, password: '', afterFailState:false});
    },
    handleDelete: function() {
        var id = parseInt(this.state.selectedId);
        if (id) {
            var user = HC_CurrentItem(this);
            return HC_Confirm(HC_LANG.ADM_DELETE_USER + " " + user.name + '"?', HC_LANG.CHL_DELETE, HC_LANG.DUE_CANCEL).then(function () {
                this.state.commandCounter++;
                this.state.needGoBack = true;
                HC_SendRequest("delete_user", {id: id}, this.successRequest, null);
            }.bind(this));
        }
    },
    handleEdit: function(o) {
        var id = parseInt(this.state.selectedId);
        if (id) {
            var data = {id: id};
            var item = HC_CurrentItem(this);

            if (item.current)
                return;

            var key = o.target.getAttribute('data-key');
            item[key] = data[key] = !item[key];

            this.setState({data: this.state.data});

            this.state.commandCounter++;
            HC_SendRequest("edit_user", data, this.successRequest, null);
        }
    },
    newPasswordChanged: function(o) {
        this.state.password = o.target.value;
        this.setState({password: o.target.value});
        HC_Validate(o.target, !this.state.afterFailState);
    },
    confPasswordChanged: function (o) {
        this.state.confirmPassword = o.target.value;
        this.setState({confirmPassword: o.target.value});
        HC_Validate(o.target, !this.state.afterFailState);
    },

    handleSetPassword: function(o) {
        if (!HC_Validate()) {
            this.state.afterFailState = true;
            return;
        }
        var id = parseInt(this.state.selectedId);
        if (id) {
            var data = {id: id};
            data.new_password = this.state.password;
            this.state.commandCounter++;
            HC_SendRequest("edit_user", data, this.successPasswordRequest, null);
            this.state.password = '';
            this.state.confirmPassword = '';
        }
    },
    handleCreateNew: function() {
        if (this.state.selectedId == -1)
            return;

        this.handleOnSelected(this.state.selectedId, true);
        this.state.data.unshift({id: -1, name: HC_LANG.ADM_NEW_USER, email: '', last_login: '', login_count: ''});
        this.setState({data: this.state.data, selectedId: -1, afterFailState: false, selectFirst:true, newUser:
            {
                acc_login: true,
                acc_reports: true,
                acc_input: true,
                acc_admin: false
            }
        });
    },
    newUserTextFieldChanged(o) {
        HC_Validate(o.target, !this.state.afterFailState);

        this.state.newUser[o.target.getAttribute('data-key')] = o.target.value;
        this.setState({newUser: this.state.newUser});
    },

    newUserBoolFieldChanged: function(o) {
        var key = o.target.getAttribute('data-key');
        this.state.newUser[key] = !this.state.newUser[key];
        this.setState({newUser: this.state.newUser});
    },
    handleUserCreate: function() {
        if (!HC_Validate())
            return;

        var data = this.state.newUser;
        this.state.needGoBack = true;
        this.state.commandCounter++;
        HC_SendRequest("add_user", data, this.successRequest, this.errorCreateRequest);
    },

    ensureGlobalValidationFunctionsCreated: function (o) {
        if (window.HC_USERS_VALIDATION != this) {
            window.HC_USERS_VALIDATION = this;

            window.HC_UsersValidation_Email = function(str) {
                var r = HC_ValidateEmail(str);
                if (r[0]) {
                    if (this.state.existingUsers[str.toLowerCase()])
                        return [false, HC_LANG.ADM_DUBL_EMAIL];
                    return [true, ""];
                }
                return r;
            }.bind(this);
            window.HC_AdmValidation_Passwords = function (str) {
                return (this.state.password === this.state.confirmPassword ? [true, ""] : [false, HC_LANG.ADM_PASS_NOTMATCH])
            }.bind(this);
        }
    },

    render: function() {
        this.ensureGlobalValidationFunctionsCreated();
        var deviceType = HC_DeviceType();
        var item = HC_CurrentItem(this);

        var licon = '', liconAction = null;
        if (deviceType == HC_CONST.SCR_PHONE || this.state.createMode) {
            licon = 'fa-angle-left';
            liconAction = this.goBack;
        }
        var ricon = "fa-trash-o";
        var riconAction = this.handleDelete;

        var checkBoxStyle = {};
        checkBoxStyle['flex'] = checkBoxStyle['WebkitFlex'] = '0 0 auto';
        var captionStyle = {marginLeft: "1rem", verticalAlign:"middle", cursor: "pointer"};
        var topCaptionStyle = {verticalAlign:"middle"};
        topCaptionStyle['flex'] = topCaptionStyle['WebkitFlex'] = '0 0 7rem';
        var divStyle = {verticalAlign:"middle", textAlign: "left", display:'flex'};
        divStyle['flexFlow'] = divStyle['WebkitFlexFlow'] = 'row';
        var divButtonStyle = {verticalAlign:"middle", textAlign: "left", display:'flex', marginTop: '1rem'};
        divButtonStyle['flexFlow'] = divButtonStyle['WebkitFlexFlow'] = 'row';
        var mainRightDiv = {position:"absolute", top:"60px"/*top-panel*/, bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', padding:"4%", paddingTop:"0.5rem"};
        var inputStyle = {};
        inputStyle['flex'] = inputStyle['WebkitFlex'] = '1 1 200px';

        if (!item) {
            item = {};
            mainRightDiv['display'] = 'none';
            ricon = "";
            riconAction = null;
        }

        var opts = {};
        if (item.current) {
            ricon = "";
            riconAction = null;
            opts.disabled = true;
        }

        var text = item.name;
        var btnsaveStyle = {marginLeft: "1rem", display: "inline-block", verticalAlign:'bottom'};
        btnsaveStyle['flex'] = btnsaveStyle['WebkitFlex'] = '0 0 5rem';

        if (this.state.createMode) {
            divStyle.marginTop = "1rem";
            divStyle.marginBottom = "1rem";
            checkBoxStyle.marginLeft = 0;
            mainRightDiv.paddingLeft = '4%';
            ricon = "";
            riconAction=null;
            text = HC_LANG.ADM_NEW_USER;
        } else {
            divStyle.marginTop = "1.5rem";
            divStyle.marginBottom = "1.5rem";
            mainRightDiv.paddingLeft = '8%';
        }

        return (
            <div id="panel-checklists" style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.ADM_CAPTION} ricon="fa-plus-circle" licon="fa-bars"
                              onLiconClick={HC_ToggleNavPanel} onRiconClick={this.handleCreateNew}/>
                    <CheckListView data={this.state.data} getCaption={this.getItemCaption} getText={this.getItemText} selectedId={this.state.selectedId} onSelect={this.handleOnSelected} showSearch={true}/>
                </div>
                <div ref="hc_user_content" className="hc-content-panel">
                    <div className="hc-internal-panel">
                        <TopPanel text={text} licon={licon} onLiconClick={liconAction} ricon={ricon}  onRiconClick={riconAction}/>

                        {(() => {
                            if (this.state.createMode) {
                                return <div style={mainRightDiv}>
                                    <div className="hc-flex-display" style={divStyle}>
                                        <div className="hc-f3 hc-f-l" style={topCaptionStyle}>{HC_LANG.ADM_FNAME}</div>
                                        <div style={inputStyle}>
                                            <input type="text" className="form-control hc-validated" data-key="first_name" value={this.state.newUser.first_name} onChange={this.newUserTextFieldChanged} data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-new-user-first-name-error"/>
                                            <div id="hc-new-user-first-name-error" style={{display: 'none'}}/>
                                        </div>
                                    </div>
                                    <div className="hc-flex-display" style={divStyle}><span className="hc-f3 hc-f-l"
                                                                                            style={topCaptionStyle}>{HC_LANG.ADM_LNAME}</span>
                                        <div style={inputStyle}>
                                            <input type="text" className="form-control  hc-validated" data-key="last_name"value={this.state.newUser.last_Name} onChange={this.newUserTextFieldChanged} style={inputStyle}  data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-new-user-last-name-error"/>
                                            <div id="hc-new-user-last-name-error" style={{display: 'none'}}/>
                                        </div>
                                    </div>
                                    <div className="hc-flex-display" style={divStyle}><span className="hc-f3 hc-f-l"
                                                                                            style={topCaptionStyle}>{HC_LANG.ADM_EMAIL + ": "}</span>
                                        <div style={inputStyle}>
                                            <input type="email" className="form-control hc-validated" data-key="email" value={this.state.newUser.email} onChange={this.newUserTextFieldChanged} style={inputStyle} data-vfunc="HC_UsersValidation_Email" data-vtext="hc-new-user-email-error" autoComplete="off"/>
                                            <div id="hc-new-user-email-error" style={{display: 'none'}}/>
                                        </div>
                                    </div>

                                    <div className="hc-flex-display" style={divStyle}><span className="hc-f3 hc-f-l"
                                                                                            style={topCaptionStyle}>{HC_LANG.ADM_PWD}</span>
                                        <div style={inputStyle}>
                                            <input type="password" className="form-control hc-validated" data-key="password" value={this.state.newUser.password} onChange={this.newUserTextFieldChanged} style={inputStyle} data-vfunc="HC_ValidatePassword" data-vtext="hc-new-user-pass-error" autoComplete="off"/>
                                            <div id="hc-new-user-pass-error" style={{display: 'none'}}/>
                                        </div>
                                    </div>
                                    <div style={{paddingLeft: "7rem"}}>
                                        <div className="hc-flex-display" style={divStyle}><input className="big-checkbox"
                                                                                                 data-key="acc_login"
                                                                                                 onChange={this.newUserBoolFieldChanged}
                                                                                                 checked={this.state.newUser.acc_login}
                                                                                                 type="checkbox"
                                                                                                 style={checkBoxStyle}/><span
                                            className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_login"
                                            onClick={this.newUserBoolFieldChanged}>{HC_LANG.ADM_LOGIN}</span></div>
                                        <div className="hc-flex-display" style={divStyle}><input className="big-checkbox"
                                                                                                 data-key="acc_reports"
                                                                                                 onChange={this.newUserBoolFieldChanged}
                                                                                                 checked={this.state.newUser.acc_reports}
                                                                                                 type="checkbox"
                                                                                                 style={checkBoxStyle}/><span
                                            className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_reports"
                                            onClick={this.newUserBoolFieldChanged}>{HC_LANG.ADM_GEN_REP}</span></div>
                                        <div className="hc-flex-display" style={divStyle}><input className="big-checkbox"
                                                                                                 data-key="acc_input"
                                                                                                 onChange={this.newUserBoolFieldChanged}
                                                                                                 checked={this.state.newUser.acc_input}
                                                                                                 type="checkbox"
                                                                                                 style={checkBoxStyle}/><span
                                            className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_input"
                                            onClick={this.newUserBoolFieldChanged}>{HC_LANG.ADM_INP_DATA}</span></div>
                                        <div className="hc-flex-display" style={divStyle}><input className="big-checkbox"
                                                                                                 data-key="acc_admin"
                                                                                                 onChange={this.newUserBoolFieldChanged}
                                                                                                 checked={this.state.newUser.acc_admin}
                                                                                                 type="checkbox"
                                                                                                 style={checkBoxStyle}/><span
                                            className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_admin"
                                            onClick={this.newUserBoolFieldChanged}>{HC_LANG.ADM_CAN_ADM}</span></div>
                                        <div className="hc-flex-display" style={$.extend({display: "flex", flexFlow: "row wrap", WebkitFlexFlow: "row wrap", alignItems:"center"}, divStyle)}>
                                            <input type="button" className="hc-button" value={HC_LANG.ADM_CREATE}
                                                   onClick={this.handleUserCreate}
                                                   style={{flex: "0 0 5rem", WebkitFlex: "0 0 5rem"}}/>
                                        </div>
                                    </div>
                                </div>
                            } else {
                                return <div style={mainRightDiv}>
                                    <div className="hc-flex-display" style={divStyle}><input data-key="acc_login"
                                                                                             className="big-checkbox"
                                                                                             type="checkbox"
                                                                                             style={checkBoxStyle}
                                                                                             checked={item.acc_login}
                                                                                             onChange={this.handleEdit}
                                                                                             disabled={item.current}/><span
                                        className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_login"
                                        onClick={this.handleEdit}>{HC_LANG.ADM_LOGIN}</span></div>
                                    <div className="hc-flex-display" style={divStyle}><input data-key="acc_reports"
                                                                                             className="big-checkbox"
                                                                                             type="checkbox"
                                                                                             style={checkBoxStyle}
                                                                                             checked={item.acc_reports}
                                                                                             onChange={this.handleEdit}
                                                                                             disabled={item.current}/><span
                                        className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_reports"
                                        onClick={this.handleEdit}>{HC_LANG.ADM_GEN_REP}</span></div>
                                    <div className="hc-flex-display" style={divStyle}><input data-key="acc_input"
                                                                                             className="big-checkbox"
                                                                                             type="checkbox"
                                                                                             style={checkBoxStyle}
                                                                                             checked={item.acc_input}
                                                                                             onChange={this.handleEdit}
                                                                                             disabled={item.current}/><span
                                        className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_input"
                                        onClick={this.handleEdit}>{HC_LANG.ADM_INP_DATA}</span></div>
                                    <div className="hc-flex-display" style={divStyle}><input data-key="acc_admin"
                                                                                             className="big-checkbox"
                                                                                             type="checkbox"
                                                                                             style={checkBoxStyle}
                                                                                             checked={item.acc_admin}
                                                                                             onChange={this.handleEdit}
                                                                                             disabled={item.current}/><span
                                        className="hc-f3 hc-f-l" style={captionStyle} data-key="acc_admin"
                                        onClick={this.handleEdit}>{HC_LANG.ADM_CAN_ADM}</span></div>

                                    <div className="hc-flex-display" style={$.extend({display: "flex", flexFlow: "row wrap", WebkitFlexFlow: "row wrap", alignItems:"flex-end", WebkitAlignItems:"flex-end"}, divButtonStyle)} >
                                        <div style={{flex: "1 1 5rem", WebkitFlex: "1 1 5rem", maxWidth: "20rem"}}>
                                            <input id="hc-user-pass" className="form-control hc-validated"
                                                   style={{width: '100%'}}
                                                   type="password" placeholder={HC_LANG.ADM_NEW_PASS}
                                                   value={this.state.password} onChange={this.newPasswordChanged}
                                                   data-vfunc="HC_ValidatePassword" data-vtext="hc-user-pass-error"
                                                   autoComplete="off"
                                            />
                                            <div id="hc-user-pass-error" style={{width: '100%', display:"none"}}/>
                                            <input id="hc-user-passconf" className="form-control hc-validated"
                                                   style={{width: '100%', marginTop:'1rem'}}
                                                   type="password" placeholder={HC_LANG.PRO_CONF_PASS}
                                                   onChange={this.confPasswordChanged} value={this.state.confirmPassword}
                                                   data-vfunc="HC_AdmValidation_Passwords" data-vtext="hc-user-pass-error2"
                                                   autoComplete="off"
                                            />
                                        </div>
                                        <input type="button" className="hc-button" value={HC_LANG.DUE_SAVE}
                                               style={btnsaveStyle} onClick={this.handleSetPassword}/>
                                    </div>
                                    <div id="hc-user-pass-error2" style={{width: '100%', display:"none"}}/>
                                </div>
                            }
                        })()}
                    </div>
                </div>
            </div>
        );
    }
});




// WEBPACK FOOTER //
// ./administrate.js